<template>
  <div class="pc-order-filling">
    <div class="breadcrumb-wrapper">
      <BreadCrumb class="breadcrumb">
        <BreadCrumbItem to="/">
          Home
        </BreadCrumbItem>
        <BreadCrumbItem to="/carts">
          Cart
        </BreadCrumbItem>
        <BreadCrumbItem>Checkout</BreadCrumbItem>
      </BreadCrumb>
    </div>
    <div
      v-if="isLoading"
      class="loading-wrapper"
    >
      <img
        :src="gifSrc"
        width="200px"
        alt=""
      >
    </div>
    <div
      v-else
      class="content"
    >
      <div class="main-info">
        <div class="shipping-methods-container">
          <div class="header">
            Shipping Methods
          </div>
          <div class="sub-text">
            Your order shipping & delivery with
            <img
              src="@/assets/order/delivery-with-logo.svg"
              alt=""
            >
          </div>
          <div class="delivery-content">
            <div
              @click="selectShippingMethod(item)"
              v-for="(item, index) in shippingList"
              :key="item.channelName"
              :class="{ checked: item?.checked }"
              class="delivery-item"
            >
              <img
                :src="item?.checked ? item.checkedIcon : item.uncheckedIcon"
                width="32px"
                alt=""
              >
              <div class="info">
                <div class="name">
                  {{ item.channelName }}
                </div>
                <div class="time">
                  Delivery time:
                  <span v-if="item?.shipPackage?.minDeliveryTime">{{ `${item?.shipPackage?.minDeliveryTime}-${item?.shipPackage?.maxDeliveryTime} days` }}</span>
                  <span v-else>Unkown days</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="product-list">
          <div
            v-for="(item, index) in productList"
            :key="index"
            class="porduct-list-item"
          >
            <div class="check-image">
              <img
                src="@/assets/H5/orderFilling/disabled-checked.svg"
                alt=""
                width="20px"
                v-if="!item.shipAmount && !item.inCheckedList"
              >
              <img
                src="https://cdn-image.bestdealer.com/app-bestdealer/1688/carts/h5-checked-icon.svg"
                alt=""
                width="20px"
                v-if="item.checked && (item.shipAmount || item.inCheckedList)"
                @click="handleProductChecked(item)"
              >
              <img
                src="https://cdn-image.bestdealer.com/app-bestdealer/1688/carts/h5-unchecked-icon.svg"
                alt=""
                width="20px"
                v-if="
                  !item.checked && (item.shipAmount || item.inCheckedList)
                "
                @click="handleProductChecked(item)"
              >
            </div>
            <div class="product-info">
              <Image
                @click="toDetailPage(item)"
                class="product-image"
                :src="item.skuImage"
                alt=""
              />
              <div class="product-detail">
                <div class="price">
                  <span>{{ currencyData?.targetCurrency?.slice(0, 2) }}&nbsp;</span>
                  <span>{{ currencyData?.targetUnit }}</span>
                  <span>{{ bankersRound(currencyData?.rate * item?.skuPriceRmb, 2) }}</span>
                </div>
                <div
                  class="spu-name"
                  @click="toDetailPage(item)"
                >
                  {{ item.spuName }}
                </div>
                <div class="attr">
                  <div class="attr-info">
                    <Image
                      class="product-image"
                      :src="item.skuImage"
                      alt=""
                    />
                    <div class="text">
                      {{ item.skuSpec?.split(";").map((x) => x.split(":")[1]).join("; ") }}
                    </div>
                  </div>
                  <div class="count">
                    x{{ item.skuQuantity }}
                  </div>
                </div>
                <div class="foot">
                  <div
                    v-if="item.shipAmount || item.inCheckedList"
                    class="subtotal"
                  >
                    <div class="label">
                      Total items:
                    </div>
                    <div class="label-price">
                      <span>{{ currencyData?.targetCurrency?.slice(0, 2) }}&nbsp;</span>
                      <span>{{ currencyData?.targetUnit }}</span>
                      <span>{{ (bankersRound(currencyData?.rate * item?.skuPriceRmb, 2) * item.skuQuantity).toFixed(2) }}</span>
                    </div>
                  </div>
                  <div 
                    v-if="Number(item.shipAmount) === 0"
                    class="free-shipping">Free Shipping</div>
                  <div 
                    v-else 
                    class="shipping-fee">
                    <div class="label">
                      Shipping fee:
                    </div>
                    <div
                      class="label-price"
                      v-if="item.shipAmount || item.inCheckedList"
                    >
                      <span>{{ currencyData?.targetCurrency?.slice(0, 2) }}&nbsp;</span>
                      <span>{{ currencyData?.targetUnit }}</span>
                      <span>{{ item.shipAmount }}</span>
                    </div>
                    <span
                      v-else
                      class="not-supported"
                    >Not supported</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="payment-methods">
          <div class="main-text">
            Payment Methods
          </div>
          <div class="sub-text">
            All transactions are secure and encrypted.
          </div>
          <div class="payment-wrapper">
            <div
              @click="payment = 1"
              class="payment-item"
              :class="{ active: payment === 1, disabled: disabledPaypal }"
            >
              <div class="left">
                <img
                  src="@/assets/H5/orderFilling/paypal.png"
                  alt=""
                >
                Pay with PayPal
              </div>
              <img
                v-if="payment === 1"
                src="@/assets/H5/orderFilling/payment-checked.svg"
                width="20px"
                alt=""
              >
              <img
                v-else
                src="@/assets/H5/orderFilling/payment-unchecked.svg"
                width="20px"
                alt=""
              >
            </div>
            <div
              @click="payment = 2"
              class="payment-item"
              :class="{ active: payment === 2 }"
            >
              <div class="left">
                <img
                  src="@/assets/H5/orderFilling/bank.png"
                  alt=""
                >
                Pay with Bank Transfer
              </div>
              <img
                v-if="payment === 2"
                src="@/assets/H5/orderFilling/payment-checked.svg"
                width="20px"
                alt=""
              >
              <img
                v-else
                src="@/assets/H5/orderFilling/payment-unchecked.svg"
                width="20px"
                alt=""
              >
            </div>
          </div>
        </div>
        <div class="shipping-address">
          <div class="main-text">
            Shipping Address
          </div>
          <div class="sub-text">
            Your address information is encrypted.
          </div>

          <div class="shipping-address-item">
            <img
              src="@/assets/H5/orderFilling/shipping-address.svg"
              alt=""
            >
            <div class="shipping-address-item-right">
              <div class="shipping-address-item-right-name">
                {{ shippingAddress?.name }}, {{ shippingAddress?.phoneValue }}
              </div>
              <div class="shipping-address-item-right-address">
                <div class="shipping-address-item-right-address-line-1">
                  {{ shippingAddress?.streetAddress }}
                </div>
                <div class="shipping-address-item-right-address-line-2">
                  {{ shippingAddress?.aptEtc }}
                </div>
                <div class="shipping-address-item-right-province">
                  {{ shippingAddress?.city }} {{ shippingAddress?.province }} ,
                  {{ shippingAddress?.postCode }} {{ shippingAddress?.country }}
                </div>
              </div>
            </div>
            <div
              class="shipping-address-item-right-edit"
              @click="showShipAddress"
            >
              Edit
            </div>
          </div>
        </div>
        <div class="bottom-line">
          <div class="text">
            I'm a bottom line.
          </div>
        </div>
      </div>
      <div
        class="right-fixed-info"
        :class="{ fixed: isFixed }"
      >
        <div class="summary-info">
          <div class="summary-info-title">
            Summary
          </div>
          <div class="summary-item">
            <div class="text">
              Total items
            </div>
            <div class="count">
              {{ currencyData?.targetCurrency.slice(0, 2) }} {{ currencyData?.targetUnit }}{{ renderItemsTotalPrice() }}
            </div>
          </div>
          <div class="summary-item">
            <div class="text flex-center">
              Shipping fee
            </div>
            <div class="price-wrapper">
              <div
                v-if="renderPrice()"
                class="shipping-old-price"
              >
                <span>{{ currencyData?.targetUnit }}</span>
                <span>{{ renderPrice() }}</span>
              </div>
              <div class="count">
                <span v-if="Number(renderShippingPrice()) <= 0" style="color: #529426;">
                  Free Shipping
                </span>
                <span v-else>
                  {{ currencyData?.targetCurrency.slice(0, 2) }} {{ currencyData?.targetUnit }}{{ renderShippingPrice() }}
                </span>
              </div>
            </div>
          </div>
          <div class="delivery-with">
            <div class="text">
              Your order shipping & delivery with
            </div>
            <img
              src="@/assets/order/delivery-with-logo.svg"
              width="73px"
              alt=""
            >
          </div>
          <div class="summary-item">
            <div class="text">
              Total
            </div>
            <div class="count">
              <IntlCurrency
                :count="renderTotalPrice()"
                :size="14"
                color="#052784"
                :currency="currencyData?.targetCurrency.slice(0, 2)"
              />
            </div>
          </div>
          <div class="split-line" />
          <div class="rate-desc">
            <div class="text">
              Current exchange rate
            </div>
            <div class="rate">
              {{ currencyData?.targetCurrency?.slice(0, 2) }} {{ currencyData?.targetUnit }}1
              =
              {{ currencyUsdData?.targetCurrency.slice(0, 2) }} {{ currencyUsdData?.targetUnit }}{{ renderToUScurrencyData() }}
            </div>
          </div>
          <div
            class="summary-item"
            v-if="discountPrice"
          >
            <div class="text">
              Discount
            </div>
            <div class="count">
              -US ${{ discountPrice }}
            </div>
          </div>
          <div class="summary-item">
            <div class="text">
              Total Amount
            </div>
            <div class="count">
              <IntlCurrency
                :count="renderTotalUSPrice()"
                :size="14"
                color="#052784"
                currency="us"
              />
            </div>
          </div>
          <div
            v-if="shippingAddress && (shippingAddress.countryCode === 'US' || EUList.includes(shippingAddress.countryCode))"
            class="tip-text"
          >
            <img
              src="@/assets/images/confirm-icon.svg"
              alt=""
            >
            <div class="text">
              <span v-if="shippingAddress.countryCode === 'US'">The Price Including Tariff</span>
              <span v-else-if="EUList.includes(shippingAddress.countryCode)">The Price Including VAT</span>
            </div>
          </div>
          <div class="button-warpper">
            <div
              class="paypal-button"
              v-show="payment === 1"
              :style="{ opacity: productList.some((item) => item.checked) ? 1 : 0.5 }"
              ref="paypalButtonContainer"
            >
              <div
                v-if="!productList.some((item) => item.checked)"
                class="disabled-paypal-button"
              />
            </div>
            <div
              v-if="payment === 2"
              @click="handleBankPayment"
              :style="{ opacity: productList.some((item) => item.checked) ? 1 : 0.5 }"
              class="place-order"
            >
              Place Order
            </div>
          </div>
        </div>
        <div class="secure-payments">
          <div class="header">
            <img
              src="@/assets/order/secure-payments.svg"
              alt=""
            >
            Secure Payments
          </div>
          <div class="payment-methods">
            Payment methods:
          </div>
          <img
            class="pay-type"
            src="@/assets/offer/pay-type.png"
            height="20px"
            alt=""
          >
        </div>
        <div class="help-text">
          <div class="text">
            Each payment you make on Bestdealer is secured with strict SSL encryption and PCI DSS data protection protocols.
          </div>
          <img
            src="@/assets/order/secure-payments-help.png"
            width="80px"
            alt=""
          >
        </div>
      </div>
    </div>

    <AddressInfoDialog
      v-if="showAddressInfo"
      @save-address="reloadPage"
      :address-type="4"
      :current-country="currentCountry"
      :handle-close="closeAddressDialog"
    />
  </div>
</template>

<script setup>
// 代码逻辑沿用h5 ...
import { ref, computed, onMounted, watch } from 'vue'
import { fetchData } from '@/utils/fetch'
import { usePlugin } from '@/hooks/usePlugin'
import { bankersRound, metaPixelTrack } from '@/utils/utils'
import { loadScript } from '@paypal/paypal-js'
import BreadCrumb from '@/components/BreadCrumb/BreadCrumb.vue'
import BreadCrumbItem from '@/components/BreadCrumb/BreadCrumbItem.vue'
import gifUrl from '@/assets/H5/empty.gif'
import economyChecked from '@/assets/H5/orderFilling/economy-checked.png'
import economyUnchecked from '@/assets/H5/orderFilling/economy-unchecked.png'
import standardChecked from '@/assets/H5/orderFilling/standard-checked.png'
import standardUnchecked from '@/assets/H5/orderFilling/standard-unchecked.png'
import expressChecked from '@/assets/H5/orderFilling/express-checked.png'
import expressUnchecked from '@/assets/H5/orderFilling/express-unchecked.png'
import freightChecked from '@/assets/H5/orderFilling/freight-checked.png'
import freightUnChecked from '@/assets/H5/orderFilling/freight-unchecked.png'
import AddressInfoDialog from '@/components/Offer/Sourcing/components/AddressInfoDialog/index.vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { buriedPointUtil, gaAnalytics } from '../../../../utils/utils'
import { useCurrency } from '@/hooks/useCurrency'
import { Image } from '@/components/Image'

const { $toast } = usePlugin()

const store = useStore()

const router = useRouter()

const { getCurrency, currentCurrency: currencyData, currencyList } = useCurrency()

const currencyUsdData = computed(() => {
  return currencyList.value?.find(item => item.targetCurrency === 'USD')
})

const isLoading = ref(true)

const shippingList = ref([])

const productList = ref([])

const payment = ref(1)

const showAddressInfo = ref(false)

const shippingAddress = ref(
  localStorage.getItem('addressForm')
    ? JSON.parse(localStorage.getItem('addressForm'))
    : null
)

// 欧盟国家列表 countryCode
const EUList = ref(['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'EL', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'])

const channelListEnum = {
  1: 'Ocean Freight',
  2: 'Economy',
  3: 'Standard',
  4: 'Express'
}

const gifSrc = computed(() => {
  return gifUrl + '?' + new Date().getTime()
})

const currentCountry = computed(() => {
  const countryList = JSON.parse(localStorage.getItem('cacheCountryList'))
  return countryList && countryList.data[0]
})

watch(isLoading, value => {
  initPaypal()
})

const getCartsList = async () => {
  try {
    const carts = sessionStorage.getItem('carts')
    if (carts) {
      const { code, data = [] } = await fetchData('/appb/b2b/cart/cartList', {
        method: 'POST',
        body: JSON.stringify({
          cartIds: JSON.parse(carts)
        })
      })
      if (code === 200) {
        if (!shippingAddress.value) {
          showAddressInfo.value = true
          return
        }
        calcFulfillmentFee(
          data.map((item) => ({ ...item, checked: true }))
        )
      }
    }
  } catch (error) {
  }
}

const onceLoading = ref(false)

let isInitiatedCheckout = false

const calcFulfillmentFee = async (items) => {
  if (!onceLoading.value) {
    isLoading.value = true
    onceLoading.value = true
  }

  const list = items || productList.value
  const checkedList = list.filter((item) => item.checked)

  const obj = {
    address: {
      ...shippingAddress.value,
      zip: shippingAddress.value?.postCode,
      phone: shippingAddress.value?.phoneValue,
      country: shippingAddress.value?.searchCountryText,
      streetAddr: shippingAddress.value?.streetAddress,
      extAddr: shippingAddress.value?.aptEtc,
      extension: shippingAddress.value?.countryCode === 'BR' ? shippingAddress.value?.cpfNumber || '' : shippingAddress.value?.countryCode === 'CL' ? shippingAddress.value?.rutNumber || '' : ''
    },
    currency: currencyData.value?.targetCurrency,
    details: checkedList.map((item) => ({
      cartId: item.cartId,
      skuId: item.skuId,
      quantity: item.skuQuantity
    }))
  }
  const { code, data, msg = '' } = await fetchData('/appb/b2b/fee/calcCartFulfillmentFee', {
    method: 'POST',
    body: JSON.stringify(obj)
  })
  if (data?.details) {
    data.details.sort((a, b) => {
      const order = { 3: 0, 1: 1, 2: 2, 4: 3 }
      return order[a.channelCode] - order[b.channelCode]
    })
  }
  if (code === 200) {
    if (!isInitiatedCheckout) {
      /**
       * Meta Pixel 埋点：完成运费计算, 单页面上报一次
       */
      metaPixelTrack('PCO401', 'InitiateCheckout', {
        content_ids: [...new Set(checkedList.map((item) => item.spuId))],
        content_type: 'product_group',
        currency: '$',
        value: 6,
        num_items: checkedList.reduce((total, cur) => {
          total += cur.skuQuantity
          return total
        }, 0)
      })
      isInitiatedCheckout = true
    }

    // 处理返回的数据
    const mappedShippingList = data.usableChannelCodes.map((code) => {
      const iconMap = {
        1: {
          checkedIcon: freightChecked,
          uncheckedIcon: freightUnChecked
        },
        2: {
          checkedIcon: economyChecked,
          uncheckedIcon: economyUnchecked
        },
        3: {
          checkedIcon: standardChecked,
          uncheckedIcon: standardUnchecked
        },
        4: {
          checkedIcon: expressChecked,
          uncheckedIcon: expressUnchecked
        }
      }
      const matchedDetail = data.details.find((d) => d.channelCode === code)
      const existingShipping = shippingList.value?.find(
        (s) => s.channelCode === code
      )

      return {
        ...(matchedDetail || {}),
        channelName: channelListEnum[code],
        checked: existingShipping
          ? existingShipping.checked
          : code === data.details?.[0]?.channelCode,
        checkedIcon: iconMap[code]?.checkedIcon,
        uncheckedIcon: iconMap[code]?.uncheckedIcon,
        channelCode: code,
        disabled: !matchedDetail // 如果details中没有对应的channelCode则禁用
      }
    })

    // 将checked为true的项放到数组第一位
    shippingList.value = [
      ...mappedShippingList.filter((item) => item.checked && !item.disabled),
      ...mappedShippingList.filter((item) => !item.checked && !item.disabled),
      ...mappedShippingList.filter((item) => item.disabled)
    ]

    const uncheckedList = list.filter((item) => !item.checked)
    productList.value = list.map((item) => ({
      ...item,
      checked:
        data.details
          .find(
            (detail) =>
              detail.channelCode ===
                shippingList.value.find((v) => v.checked)?.channelCode &&
              detail.singleShipPackages?.some((pkg) =>
                pkg.skuIds?.includes(item.skuId)
              )
          )
          ?.singleShipPackages?.some((pkg) =>
            pkg.skuIds?.includes(item.skuId)
          ) ?? false,
      inCheckedList: Boolean(
        uncheckedList.some((checkedItem) => checkedItem.skuId === item.skuId)
      ),
      ...data.details
        .find(
          (detail) =>
            detail.channelCode ===
              shippingList.value.find((v) => v.checked)?.channelCode &&
            detail.singleShipPackages?.some((pkg) =>
              pkg.skuIds?.includes(item.skuId)
            )
        )
        ?.singleShipPackages?.find((pkg) => pkg.skuIds?.includes(item.skuId))
    }))
    productList.value.forEach(item => {
      updateProductSkuPrice(item)
    })
    isLoading.value = false
  } else {
    $toast(msg, { type: 'warning' })
    isLoading.value = false
  }
}

const handleProductChecked = async (item) => {
  if (item.shipAmount || item.inCheckedList) {
    // 如果当前是最后一个选中的商品且要取消选中,则不允许取消
    if (
      item.checked &&
      productList.value.filter((i) => i.checked).length === 1
    ) {
      $toast('Please select at least one item', { type: 'warning' })
      return
    }
    item.checked = !item.checked
    await calcFulfillmentFee()
  }
}

const getClientId = async () => {
  const { code, data } = await fetchData('/appb/b2b/pay/getPaypalClientId', {
    method: 'get'
  })
  if (code === 200) {
    return data
  }
  return 'Ad-U4AlBoG22sqpaaAcLGpCdrJqSK7jZXHebOxhfyrr-ngI9JCvZ6GmIuUKs1ZWR99t1xmx6d2y6S-RP'
}

const paypalButtonContainer = ref(null)
const initPaypal = async () => {
  const clientId = await getClientId()
  try {
    // 提前加载PayPal脚本
    const paypal = await loadScript({
      'client-id': clientId,
      intent: 'capture',
      components: 'buttons',
      'disable-funding': 'paylater',
      // 添加缓存策略
      'data-csp-nonce': 'xyz',
      'data-page-type': 'checkout'
      // 设置超时时间
    })

    // 按钮配置
    const buttonConfig = {
      style: {
        layout: 'vertical',
        shape: 'pill',
        size: 'small',
        tagline: false
      },
      // 创建订单
      createOrder: async () => {
        gaAnalytics('p_place_order_click', 'p_place_order_click')
        gaAnalytics('p_paypal_click', 'p_paypal_click')

        try {
          const data = await createOrder('PAYPAL_STANDARD_B2B')
          buriedPointUtil({ eventId: 'PPP601' })
          localStorage.setItem('tradeCode', data.tradeCode)
          return data.thirdTradeCode
        } catch (err) {
          throw err
        }
      },
      // 支付成功
      onApprove: async (data) => {
        try {
          const tradeCode = localStorage.getItem('tradeCode')
          const orderNo = localStorage.getItem('orderNo')

          const { code } = await fetchData(
            '/appb/b2b/order/completePayAction',
            {
              method: 'POST',
              body: JSON.stringify({
                orderNo,
                tradeCode
              })
            }
          )

          gaAnalytics('P_Pay_Success', 'P_Pay_Success')
          gaAnalytics('p_pay_success', 'p_pay_success')

          const checkedList = productList.value.filter((item) => item.checked)

          /**
           * Meta Pixel 埋点：银行转账提交支付审核
           */
          metaPixelTrack('POP401', 'Purchase', {
            content_ids: [...new Set(checkedList.map((item) => item.spuId))],
            content_type: 'product_group',
            currency: '$',
            value: 9,
            num_items: checkedList.reduce((total, cur) => {
              total += cur.skuQuantity
              return total
            }, 0)
          })

          if (localStorage.getItem('buy-again')) {
            gaAnalytics('p_buy_again_success', 'p_buy_again_success')
            localStorage.removeItem('buy-again')
          }
          localStorage.removeItem('tradeCode')
          localStorage.removeItem('orderNo')
          router.push(`/bankPayment/${orderNo}?type=paidSuccess`)
        } catch (err) {
          console.error('支付完成失败:', err)
          throw err
        }
      },
      // 取消支付
      onCancel: async () => {
        localStorage.removeItem('tradeCode')
        localStorage.removeItem('orderNo')
        router.replace('/orders?status=1')
      },
      // 支付错误
      onError: async (err) => {
        console.error('支付错误:', err)
        localStorage.removeItem('tradeCode')
        localStorage.removeItem('orderNo')

        if (localStorage.getItem('orderErrorCode')) {
          localStorage.removeItem('orderErrorCode')
          return
        }
        router.replace('/orders?status=1')
      }
    }

    // 渲染按钮
    await paypal.Buttons(buttonConfig).render(paypalButtonContainer.value)
  } catch (err) {
    console.error('PayPal初始化失败:', err)
    // 错误处理
    setTimeout(() => {
      initPaypal() // 如果加载失败,3秒后重试
    }, 3000)
  }
}

const showShipAddress = () => {
  showAddressInfo.value = true
}

const closeAddressDialog = () => {
  isLoading.value = false
  showAddressInfo.value = false
  if (!shippingAddress.value) {
    router.go(-1)
  }
}

const disabledPaypal = ref(false)
const payPalDisabled = (totalShipCost) => {
  if (Number(totalShipCost) >= 500) {
    payment.value = 2
    disabledPaypal.value = true
  } else {
    disabledPaypal.value = false
  }
}

const isFixed = ref(false)
const handleScroll = (event) => {
  if (window.scrollY > 221) {
    isFixed.value = true
  } else {
    isFixed.value = false
  }
}

const renderItemsTotalPrice = () => {
  if (!productList.value.some((item) => item.checked)) {
    return '0.00'
  }
  return (
    shippingList.value.find((v) => v.checked)?.shipPackage?.itemAmount || 0
  )
}

const renderPrice = () => {
  if (!productList.value.some((item) => item.checked)) {
    return 0
  }
  const shipCostTotal = shippingList.value.find((v) => v.checked)?.shipPackage
    ?.shipAmount

  const totalShipCost = productList.value
    .filter((item) => item.checked)
    .reduce((sum, item) => sum + Number(item.shipAmount), 0)

  return totalShipCost > shipCostTotal ? totalShipCost.toFixed(2) : false
}

const renderShippingPrice = () => {
  if (!productList.value.some((item) => item.checked)) {
    return '0.00'
  }
  const shipCostTotal = shippingList.value.find((v) => v.checked)?.shipPackage?.shipAmount
  return isNaN(shipCostTotal) ? 0 : shipCostTotal
}

const renderTotalPrice = () => {
  if (!productList.value.some((item) => item.checked)) {
    return '0.00'
  }
  return shippingList.value.find((v) => v.checked)?.shipPackage?.totalAmount
}

const discountPrice = computed(() => {
  return shippingList.value.find(item => item.checked)?.shipPackage.discountAmountUsd
})

const renderTotalUSPrice = () => {
  if (!productList.value.some((item) => item.checked)) {
    return '0.00'
  }
  const totalAmount =
    shippingList.value.find((v) => v.checked)?.shipPackage?.finalTotalAmountUsd ||
    '0.00'
  payPalDisabled(totalAmount)
  return totalAmount
}

const renderToUScurrencyData = () => {
  const selected = shippingList.value.find((v) => v.checked)

  if (selected == null) return 0

  const { totalAmount, totalAmountUsd } = selected.shipPackage

  const rate = totalAmountUsd / totalAmount

  return bankersRound(rate, 6)
}

const createOrder = async (paymentMethodCode) => {
  try {
    const selected = shippingList.value.find((v) => v.checked)
    if (!selected) throw new Error('shippingList is empty')
    const { code, data, msg } = await fetchData(
      '/appb/b2b/order/placeCartOrder',
      {
        method: 'POST',
        body: JSON.stringify({
          fulfillmentAmount: selected.shipPackage.totalAmount,
          discountAmountUsd: selected.shipPackage.discountAmountUsd,
          shipChannel: selected.channelCode,
          currency: currencyData.value?.targetCurrency,
          details: productList.value
            .filter((item) => item.checked)
            .map((item) => ({
              cartId: item.cartId,
              quantity: item.skuQuantity,
              skuId: item.skuId
            })),
          address: {
            ...shippingAddress.value,
            zip: shippingAddress.value?.postCode,
            phone: shippingAddress.value?.phoneValue,
            country: shippingAddress.value?.searchCountryText,
            streetAddr: shippingAddress.value?.streetAddress,
            extAddr: shippingAddress.value?.aptEtc,
            extension: shippingAddress.value?.countryCode === 'BR' ? shippingAddress.value?.cpfNumber || '' : shippingAddress.value?.countryCode === 'CL' ? shippingAddress.value?.rutNumber || '' : ''
          }
        })
      }
    )
    if (code === 200) {
      localStorage.setItem('orderNo', data)
      if (paymentMethodCode === 'BANK_TRANSFER_B2B') {
        return data
      }
      const { code: payCode, data: payData } = await fetchData(
        '/appb/b2b/order/createOrderPay',
        {
          method: 'POST',
          body: JSON.stringify({
            orderNo: data,
            paymentMethodCode,
            receiptInfos: productList.value.map((item) => item.skuImage)
          })
        }
      )
      if (payCode === 200) {
        buriedPointUtil({ eventId: 'PPP201', others: { type: 'PayPal' } })
        gaAnalytics('p_place_order_success', 'p_place_order_success')
        getCartCount()
        return payData
      }
    } else {
      if (code === 500) {
        localStorage.setItem('orderErrorCode', 500)
      }
      $toast(msg, { type: 'error' })
    }
    return null
  } catch (error) {
    $toast(error.msg || error.message, { type: 'error' })
    return null
  }
}

const handleBankPayment = async () => {
  if (!productList.value.some((item) => item.checked)) {
    return
  }
  gaAnalytics('p_place_order_click', 'p_place_order_click')
  gaAnalytics('p_pay_with_bank_click', 'p_pay_with_bank_click')
  try {
    const data = await createOrder('BANK_TRANSFER_B2B')

    getCartCount()
    if (data) {
      buriedPointUtil({ eventId: 'PPP601' })
      buriedPointUtil({ eventId: 'PPP201', others: { type: 'Bank' } })
      gaAnalytics('p_place_order_success', 'p_place_order_success')

      router.replace(`/bankPayment/${data}`)
      $toast('Order created successfully', { type: 'success' })
    } else {
      $toast(msg, { type: 'error' })
    }
  } catch (error) {}
}

const getCartCount = async () => {
  const { code, data } = await fetchData('/appb/b2b/cart/cartCount')
  if (code === 200) {
    store.commit('cart/SET_CART_COUNT', data)
  }
}

const selectShippingMethod = (item) => {
  if (item.disabled) {
    return
  }
  shippingList.value.forEach((item) => {
    item.checked = false
  })
  item.checked = true
  // 把选中的项目移到第一位
  const index = shippingList.value.findIndex(
    (i) => i.channelCode === item.channelCode
  )
  if (index > 0) {
    const selected = shippingList.value.splice(index, 1)[0]
    shippingList.value.unshift(selected)
  }
  productList.value = productList.value.map((item) => {
    const selectedShipping = shippingList.value.find((v) => v.checked)
    const matchedPackage = selectedShipping?.singleShipPackages?.find((pkg) =>
      pkg.skuIds?.includes(item.skuId)
    )
    return {
      ...item,
      shipAmount: matchedPackage?.shipAmount || 0,
      totalAmount: matchedPackage?.totalAmount || 0
    }
  })
}

const reloadPage = () => {
  location.reload()
}

// 获取起批量对应价格
const getPriceByQuantity = (quantity, priceRange) => {
  let validPrices = priceRange.filter(item => item.startQuantity <= quantity)
  if (validPrices.length === 0) {
    validPrices = [priceRange[0]]
  }

  const bestMatch = validPrices.reduce((prev, curr) =>
    curr.startQuantity > prev.startQuantity ? curr : prev
  )

  return Number(bestMatch.price)
}

// 更新同级商品下sku价格
const updateProductSkuPrice = (obj) => {
  // 先更新自身
  obj.skuPriceRmb = getPriceByQuantity(obj.skuQuantity, obj.skuPriceCnyRanges)

  // 单个区间 return
  const skuPriceCnyRanges = obj.skuPriceCnyRanges || []
  if (skuPriceCnyRanges.length < 2) return

  // 获取已选中的同个商品级别下的sku加购总数
  let count = 0
  const checkedList = productList.value.filter(v => v.checked)
  const sameProductLevelSku = checkedList.filter(v => v.spuId === obj.spuId)
  sameProductLevelSku.forEach(item => {
    count += item.skuQuantity
  })

  if (count) {
    const skuPriceRmb = getPriceByQuantity(count, obj.skuPriceCnyRanges)
    // 同级sku同步更新金额
    sameProductLevelSku.forEach(item => item.skuPriceRmb = skuPriceRmb)
  }
}

const toDetailPage = (item) => {
  const { href } = router.resolve({
    path: `/offer/${item.spuId}`
  })
  window.open(href, '_blank')
}

onMounted(async () => {
  if (shippingAddress.value) {
    buriedPointUtil({ eventId: 'PPP501' })
  }
  window.addEventListener('scroll', handleScroll)

  await getCurrency()
  await getCartsList()
})

</script>

<style lang='less' scoped>
.pc-order-filling {
  --cart-width: 850px;
  min-height: calc(100vh - 220.5px - 128px);
  .breadcrumb-wrapper {
    display: flex;
    align-items: center;
    height: 48px;
    border-bottom: 1px solid var(--main-border-color);

    .breadcrumb {
      width: 1200px;
      margin: 0 auto;
    }
  }
  .loading-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 220px - 128px - 48px);
  }

  .content {
    position: relative;
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 1200px;
    margin: 0 auto;
    margin-top: 24px;

    .main-info {
      width: 850px;
    }

    .shipping-methods-container {
      width: 850px;
      padding-bottom: 24px;
      border-bottom: 1px solid var(--light-split-color);
      .header {
        color: #232323;
        font-size: 16px;
        font-family: mon-600;
        line-height: 24px;
      }
      .sub-text {
        display: flex;
        align-items: center;
        gap: 4px;
        color: #5c5c5c;
        font-size: 12px;
        font-family: mon-500;
        margin-top: 2px;
        line-height: 16px;
      }

      .delivery-content {
        display: flex;
        gap: 12px;
        margin-top: 16px;

        .delivery-item {
          display: flex;
          gap: 16px;
          width: 275px;
          border: 1px solid #ebf1f5;
          border-radius: 4px;
          padding: 15px 24px;
          background-color: #f8f8f8;
          &:hover {
            outline: 1.5px solid #232323;
            outline-offset: -1.5px;
          }

          &.checked {
            outline: 1.5px solid #232323;
            outline-offset: -1.5px;
          }

          .info {
            .name {
              color: #232323;
              font-size: 14px;
              font-family: mon-600;
              line-height: 18px;
            }

            .time {
              margin-top: 2px;
              color: #6e717a;
              font-size: 11px;
              font-family: mon-500;
              line-height: 16px;
              color: #232323;
              span {
                font-size: 12px;
                font-family: mon-500;
              }
            }
          }
        }
      }
    }
    .product-list {
      margin: 24px 0 48px 0;
      .check-image {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .porduct-list-item {
        position: relative;
        display: flex;
        gap: 16px;
        width: 850px;
        height: 120px;
        margin-bottom: 32px;

        &::after {
          content: '';
          position: absolute;
          bottom: -16px;
          right: 0;
          width: calc(690px - 16px);
          height: 1px;
          background-color: var(--light-split-color);
        }

        .product-info {
          display: flex;
          gap: 16px;
          .product-image {
            width: 120px;
            height: 120px;
            border-radius: 4px;
            cursor: pointer;
          }
          .product-detail {
            overflow: hidden;
            .price {
              display: flex;
              color: #232323;
              font-size: 12px;
              font-family: mon-600;
              line-height: 20px;
            }
            .spu-name {
              width: 622px;
              margin-top: 4px;
              color: #5c5c5c;
              font-size: 13px;
              font-family: mon-500;
              line-height: 16px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              cursor: pointer;
            }
            .attr {
              display: flex;
              align-items: center;
              gap: 8px;
              margin-top: 12px;
              .attr-info {
                display: flex;
                align-items: center;
                gap: 6px;
                padding: 4px;
                padding-right: 8px;
                min-width: 200px;
                max-width: 400px;
                border-radius: 2px;
                background-color: #f8f8f8;
                .product-image {
                  width: 16px;
                  height: 16px;
                  border-radius: 1px;
                }

                .text {
                  color: #63717a;
                  font-size: 12px;
                  font-family: mon-500;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
              .count {
                font-size: 12px;
                font-family: mon-500;
                color: #5c5c5c;
              }
            }
            .foot {
              display: flex;
              align-items: center;
              gap: 12px;
              margin-top: 24px;
              .free-shipping {
                color: #529426;
                font-size: 12px;
                font-family: mon-500;
              }
              .shipping-fee {
                display: flex;
                align-items: center;
                font-size: 12px;
                font-family: mon-500;
                color: #232323;
                .label-price {
                  margin-left: 4px;
                  font-family: mon-600;
                }
                .not-supported {
                  color: #f53131;
                  margin-left: 4px;
                }
              }
              .subtotal {
                display: flex;
                align-items: center;
                color: #232323;
                font-size: 12px;
                font-family: mon-500;

                .label-price {
                  margin-left: 4px;
                  font-family: mon-600;
                }
              }
            }
          }
        }
      }
    }

    .payment-methods {
      .main-text {
        color: #232323;
        font-size: 16px;
        font-family: mon-600;
        line-height: 24px;
      }
      .sub-text {
        margin-top: 2px;
        color: #5c5c5c;
        font-size: 12px;
        font-family: mon-500;
        line-height: 16px;
      }

      .payment-wrapper {
        display: flex;
        gap: 12px;
        margin-top: 16px;
        .payment-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 419px;
          height: 64px;
          border-radius: 4px;
          border: 1px solid #ebf1f5;
          padding: 16px 24px;
          &:hover {
            outline: 1.5px solid #232323;
            cursor: pointer;
          }
          &.active {
            outline: 1.5px solid #232323;
            cursor: pointer;
          }
          &.disabled {
            opacity: .5;
            cursor: not-allowed;
          }
          .left {
            display: flex;
            align-items: center;
            color: #232323;
            font-size: 13px;
            font-family: mon-600;
            img {
              width: 75px;
              margin-right: 10px;
            }
          }
        }
      }
    }

    .shipping-address {
      margin-top: 32px;
      .main-text {
        color: #232323;
        font-size: 16px;
        font-family: mon-600;
        line-height: 24px;
      }
      .sub-text {
        margin-top: 2px;
        color: #5c5c5c;
        font-size: 12px;
        font-family: mon-500;
        line-height: 16px;
      }
      .shipping-address-item {
        position: relative;
        border: 1px solid #EBF1F5;
        border-radius: 8px;
        padding: 16px 24px;
        display: flex;
        align-items: center;
        margin-top: 16px;
        .shipping-address-item-right {
          margin-left: 20px;
          .shipping-address-item-right-name {
            font-family: mon-600;
            font-size: 12px;
            color: #232323;
            line-height: 16px;
            margin-bottom: 2px;
          }
          .shipping-address-item-right-address {
            font-family: mon-500;
            font-size: 12px;
            color: #5C5C5C;
            line-height: 16px;
            .shipping-address-item-right-address-line-1 {
              margin-bottom: 2px;
              color: #5c5c5c;
            }
            .shipping-address-item-right-address-line-2 {
              margin-bottom: 2px;
              color: #5c5c5c;
            }
            .shipping-address-item-right-province {
              margin-bottom: 2px;
              color: #5c5c5c;
            }
          }
        }

        .shipping-address-item-right-edit {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 24px;
          font-size: 12px;
          color: #009DE0;
          line-height: 16px;
          font-family: mon-600;
          text-decoration: underline;
          cursor: pointer;
          &:hover {
            color: var(--link-hover-color);
          }
        }
      }
    }

    .bottom-line {
      display: flex;
      justify-content: flex-end;
      padding-right: 152px;
      margin-top: 64px;
      .text {
        position: relative;
        height: 16px;
        width: 195px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #b2b7c2;
        font-size: 12px;
        font-family: mon-500;
        &::after, &::before {
          content: '';
          position: absolute;
          width: 32px;
          height: 1px;
          background-color: #ebebeb;
        }
        &::after {
          right: 0;
        }
        &::before {
          left: 0;
        }
      }
    }
  }

  .right-fixed-info {
    &.fixed {
      position: fixed;
      top: 24px;
      right: calc((100vw - 1200px) / 2);
    }
    .summary-info {
      width: 286px;
      border-radius: 8px;
      background-color: #f8f8f8;
      padding: 16px;
      .summary-info-title {
        color: #232323;
        font-size: 14px;
        font-family: mon-700;
        margin-bottom: 16px;
      }
      .summary-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #232323;
        font-size: 12px;
        font-family: mon-600;
        margin-bottom: 12px;
        &:last-child {
          margin-bottom: 0;
        }

        .flex-center {
          display: flex;
          align-items: center;
          gap: 4px;
          img {
            cursor: pointer;
          }
        }

        .count {
          font-size: 12px;
          font-family: mon-600;
          color: #232323;
        }

        .price-wrapper {
          display: flex;
          align-items: center;
          gap: 4px;
          .shipping-old-price {
            color: #b2b7c2;
            font-size: 11px;
            font-family: mon-500;
            text-decoration: line-through;
          }
        }
      }
      .delivery-with {
        display: flex;
        flex-direction: column;
        margin-top: -6px;
        margin-bottom: 12px;
        .text {
          color: #6e717a;
          font-size: 11px;
          font-family: mon-500;
          line-height: 16px;
          margin-bottom: 2px;
        }
      }
      .tip-text {
        display: flex;
        align-items: flex-start;
        gap: 6px;
        width: 254px;
        border-radius: 4px;
        border: 1px solid #DFE8FB;
        padding: 8px 12px;
        background-color: #EFF4FD;
        .text {
          color: #1153d6;
          font-size: 11px;
          font-family: mon-500;
          line-height: 16px;
        }
      }
      .split-line {
        border: 0.5px solid var(--dark-split-color);
        margin-bottom: 8px;
      }
      .rate-desc {
        display: flex;
        justify-content: space-between;
        color: #6e717a;
        font-size: 11px;
        font-family: mon-500;
        line-height: 16px;
        margin-bottom: 18px;
      }
      .button-warpper {
        margin-top: 16px;

        .paypal-button {
          position: relative;
          .disabled-paypal-button {
            position: absolute;
            top: 0;
            height: 100%;
            width: 100%;
            z-index: 999;
          }
        }
        .tip-text {
          display: flex;
          align-items: flex-start;
          gap: 6px;
          width: 254px;
          height: 48px;
          border-radius: 4px;
          border: 0.5px solid #bad7f5;
          padding: 8px 12px;
          background-color: #ebf5ff;
          .text {
            color: #1153d6;
            font-size: 11px;
            font-family: mon-500;
            line-height: 16px;
          }
        }
        .place-order {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 254px;
          height: 36px;
          border-radius: 20px;
          background-color: #052784;
          color: white;
          font-size: 14px;
          font-family: mon-600;
          margin-top: 12px;
          cursor: pointer;
        }
      }
    }
    .secure-payments {
      margin-top: 16px;
      .header {
        display: flex;
        align-items: center;
        color: #232323;
        font-size: 14px;
        font-family: mon-600;
        img {
          margin-right: 8px;
        }
      }
      .payment-methods {
        margin-left: 32px;
        margin-top: 4px;
        margin-bottom: 2px;
        color: #5c5c5c;
        font-size: 12px;
        font-family: mon-500;
        line-height: 16px;
      }
      .pay-type {
        margin-left: 32px;
      }
    }
    .help-text {
      display: flex;
      align-items: center;
      margin-top: 12px;
      padding: 16px 12px;
      width: 286px;
      border: 1px solid var(--main-border-color);
      border-radius: 6px;
      .text {
        color: #5c5c5c;
        font-size: 11px;
        font-family: mon-500;
        line-height: 16px;
      }
    }
  }
}
</style>
